//layout
import AuthLayout from "../containers/Layouts/AuthLayout/AuthLayout";
import MainLayout from "../containers/Layouts/MainLayout/MainLayout";
import DetailUnitLayout from "../containers/Layouts/CustomLayout/DetailUnitLayout.js";
import DetailUnitInternal from "../pages/DetailUnit/DetailUnitInternal";
import LupaPassword from "../pages/Auth/LupaPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import ResetPasswordInvalid from "../pages/Auth/ResetPasswordInvalid";
import LupaPasswordBerhasil from "../pages/Auth/LupaPasswordBerhasil";
import SignIn from "../pages/Auth/SignIn";
import Otp from "../pages/Auth/Otp";
import SignUp from "../pages/Auth/SignUp";
import VerifikasiAkun from "../pages/Auth/VerifikasiAkun";
import BeliNIPL from "../pages/BeliNIPL/BeliNIPL";
import DetailTransaksi from "../pages/DetailTransaksi/DetailTransaksi";
import RegularAuction from "../pages/LiveAuction/RegularAuction";
import RegularAuctionGo from "../pages/LiveAuction/RegularAuctionGo";
import Setting from "../pages/Setting/Setting";
import Checkout from "../pages/Checkout/Checkout.js";
import DetailTransaksiPenjualan from "../pages/DetailTransaksi/DetailTransaksiPenjualan";
import TimeBidAuctionGo from "../pages/LiveAuction/TimeBidAuctionGo";
import CloseBidAuction from "../pages/LiveAuction/CloseBidAuction.js";
import CloseBidAuctionGo from "../pages/LiveAuction/CloseBidAuctionGo.js";
// import LiveAuctionPublic from "../pages/LiveAuctionPublic/LiveAuctionPublic";
// import FullscreenLayout from "../containers/Layouts/FullscreenLayout.js/FullscreenLayout";

export const authList = [
  {
    path: "/masuk",
    component: SignIn,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/otp",
    component: Otp,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/daftar",
    component: SignUp,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/verifikasi-akun",
    component: VerifikasiAkun,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/lupa-password",
    component: LupaPassword,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/lupa-password-berhasil",
    component: LupaPasswordBerhasil,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/reset-password/:token/:email",
    component: ResetPassword,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/reset-password-invalid",
    component: ResetPasswordInvalid,
    layout: AuthLayout,
    isLogged: false,
  },
  {
    path: "/beli-nipl",
    component: BeliNIPL,
    layout: MainLayout,
    isLogged: true,
  },
  {
    path: "/checkout",
    component: Checkout,
    layout: MainLayout,
    isLogged: true,
  },
  {
    path: "/pengaturan/transaksi/pembelian/:id",
    component: DetailTransaksi,
    layout: MainLayout,
    isLogged: true,
  },
  {
    path: "/pengaturan/transaksi/penjualan/:id",
    component: DetailTransaksiPenjualan,
    layout: MainLayout,
    isLogged: true,
  },
  {
    // Halaman detail unit versi internal (gated login): tetap bisa diakses walau
    // lelang sudah lampau, dan selalu di-noindex. Untuk konsumsi internal via link.
    path: "/internal/unit-lelang/:id",
    component: DetailUnitInternal,
    layout: DetailUnitLayout,
    isLogged: true,
  },
  {
    path: "/pengaturan/:type",
    component: Setting,
    layout: MainLayout,
    isLogged: true,
  },
  // {
  //     path: '/live-auction/:id/public',
  //     component: LiveAuctionPublic,
  //     layout: FullscreenLayout,
  //     isLogged: false,
  // },
  // {
  //   path: "/live-auction/:id",
  //   component: RegularAuction,
  //   layout: MainLayout,
  //   isLogged: true,
  // },
  {
    path: "/live-auction/:id",
    component: RegularAuctionGo,
    layout: MainLayout,
    isLogged: true,
  },
  {
    path: "/time-bid-auction/:id/:unitId",
    component: TimeBidAuctionGo,
    layout: MainLayout,
    isLogged: true,
  },
  {
    path: "/close-bid-auction/:id/:unitId",
    component: CloseBidAuctionGo,
    layout: MainLayout,
    isLogged: true,
  },
];
